import React from 'react';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';
import { toSvgColor } from 'apps/sigma2-ui/src/components/svg/types';

export const SortIconSvgGroup: React.FC<SvgProps> = (props) => {
  const fillColor = toSvgColor('#696D70', props);

  return (
    <g fill="none" {...(props.group ?? {})}>
      <g>
        <path
          d="M5.30382 2.37803C4.9977 2.07191 4.50055 2.07191 4.19443 2.37803L1.05974 5.51272C0.834432 5.73803 0.76831 6.07354 0.890757 6.36741C1.0132 6.66129 1.29729 6.85231 1.61566 6.85231H7.88504C8.20096 6.85231 8.48749 6.66129 8.60994 6.36741C8.73239 6.07354 8.66382 5.73803 8.44096 5.51272L5.30627 2.37803H5.30382Z"
          fill={fillColor}
        />
      </g>
    </g>
  );
};

export const SortIconSvg: React.FC<SvgProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="9"
      height="9"
      viewBox="0 0 9 9"
      fill="none"
      {...(props.svg ?? {})}
    >
      <SortIconSvgGroup {...props} />
    </svg>
  );
};
